
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.737 4.045a.75.75 0 01.596-.295h8.334a.75.75 0 01.596.295l3.333 4.363a.75.75 0 01-.051.971l-7.222 7.636a.75.75 0 01-1.07.02L2.474 9.4a.75.75 0 01-.071-.99l3.333-4.364zm.967 1.205L4.517 8.114h11.966L14.296 5.25H6.704zm9.554 4.364H4.834l5.924 5.816 5.5-5.816z","fill":"currentColor"}})])
          )
        }
      }
    